export class TableTypeModel {
  public id: string;
  public index: number = 0;
  public type: string;
  public shape: string;
  public name: string;
  public yPosition: string | number = '0';
  public xPosition: string | number = '0';
  public numberOfPeople: number;
  public status: number;
}
